function getRecursivelyCheckedNodes(tree) {
    return tree.reduce((acc, current)=>{
        if (!current.$visible) {
            return acc;
        }
        if (current.checked) {
            acc.push(current);
        }
        if (current.childNodes?.length) {
            acc.push(...getRecursivelyCheckedNodes(current.childNodes));
        }
        return acc;
    }, []);
}
function uuid() {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        return `aiot-${crypto.randomUUID()}`;
    }
    return `aiot-${Date.now().toString(16)}`;
}
export { getRecursivelyCheckedNodes, uuid };
